import styled from 'styled-components/macro';

export const Container = styled.div`
  min-height: calc(100vh - 68px);
  padding: 0 20px;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const PageTitle = styled.div`
  font-size: 21px;
  color: #006f93;
  line-height: 25px;
  font-weight: 500;
`;
